import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import type { UserProfile } from "@chuzi/shared/types";
import { ErrorBoundary } from "./components/error-boundary";
import { RealmProvider } from "./lib/realm";
import { SpendingModalProvider } from "./lib/spending-modal";
import { api } from "./lib/api";
import { auth } from "./lib/auth";
import { AuthCallbackPage } from "./pages/auth-callback";
import { LoginPage } from "./pages/login";
import { CatalogPage } from "./pages/catalog";
import { DirectorPage } from "./pages/director";
import { EditorPage } from "./pages/editor";
import { MyRealmPage } from "./pages/my-realm";

function CreditsShell({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<UserProfile | null>(null);

  useEffect(() => {
    if (!auth.isAuthenticated()) return;
    let cancelled = false;
    api.auth
      .user()
      .then((profile) => {
        if (!cancelled) setUser(profile);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <SpendingModalProvider
      user={user}
      onBalanceUpdated={(balance) => {
        window.dispatchEvent(
          new CustomEvent("chuzi:credits-updated", { detail: balance }),
        );
      }}
    >
      {children}
    </SpendingModalProvider>
  );
}

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <RealmProvider>
          <CreditsShell>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/magic-link" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/my" element={<MyRealmPage />} />
            <Route path="/all" element={<MyRealmPage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/directors/:id" element={<DirectorPage />} />
            <Route path="/editor/:storyId" element={<EditorPage />} />
            <Route path="*" element={<Navigate to="/my" replace />} />
          </Routes>
          </CreditsShell>
        </RealmProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
